import React from 'react';
import PropTypes from 'prop-types';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { reduxForm } from 'redux-form';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import RenderLocalisationInputField from 'components/form/InputFields/RenderLocalisationInputField';

class ProductLocalisationEditForm extends React.Component {
    constructor(props) {
        super(props);

        const {
            initialize,
            localisation,
        } = props;

        initialize({
            localisation: localisation,
        });
    }

    render() {
        const {
            form,
            localisation,
            handleSubmit,
            handleSubmitForm,
            submitting,
            localisationFields,
        } = this.props;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) } >
                    <Section>
                        <Row>
                            <Item>
                                <RenderLocalisationInputField
                                    localisation={ localisation }
                                    fields={ localisationFields }
                                    form={ form }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ submitting }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

ProductLocalisationEditForm.defaultProps = {
    localisationFields: [
        {
            maxLength: 10000,
            name: 'description',
            type: 'textarea',
        },
        {
            maxLength: 1500,
            name: 'instruction',
            required: true,
            type: 'textarea',
        },
        {
            maxLength: 1500,
            name: 'instruction_inbound',
            type: 'textarea',
        },
        {
            maxLength: 1500,
            name: 'instruction_outbound',
            type: 'textarea',
        },
        {
            maxLength: 160,
            name: 'text_message_inbound',
            type: 'textarea',
        },
        {
            maxLength: 160,
            name: 'text_message_outbound',
            type: 'textarea',
        },
    ],
};

ProductLocalisationEditForm.propTypes = {
    form: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    localisation: PropTypes.object,
    localisationFields: PropTypes.array,
    submitting: PropTypes.bool,
};

const enhance = compose(
    translate,
    reduxForm(),
);

export default enhance(ProductLocalisationEditForm);



// WEBPACK FOOTER //
// ./src/pages/products/productLocalisation/edit/ProductLocalisationEditForm.js